// contexts/UserContext.js
import React, {
  createContext, useContext, useState,
  useMemo,
} from 'react';

// Create the context
const UserContext = createContext();

// Custom hook to use the user context
export const useMiscellaneousData = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useMiscellaneousData must be used within a UserProvider');
  }
  return context;
};

// User Provider component
export function MiscellaneousDataProvider({ children, initialData }) {
  const [miscellaneousData, setMiscellaneousData] = useState(initialData || {});

  // Query to refetch user data on client-side if needed

  // Check if user is authenticated

  const value = useMemo(() => ({
    miscellaneousData,
    setMiscellaneousData,
  }), [miscellaneousData]);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export default UserContext;
